import React, {Component} from 'react';
import PropTypes from 'prop-types';

class HeatMapHovers extends Component {

  render() {
    const x0 = 0;
    const x1 = this.props.hoverCol * this.props.cellSize;
    const x2 = this.props.hoverCol * this.props.cellSize + this.props.cellSize;
    const x3 = this.props.width;
    const y0 = 0;
    const y1 = this.props.hoverRow * this.props.cellSize;
    const y2 = this.props.hoverRow * this.props.cellSize + this.props.cellSize;
    const y3 = this.props.height;

    const hasRow = this.props.hoverRow > -1;
    const hasCol = this.props.hoverCol > -1;

    return (
      <g className="grid">
        {hasRow && !hasCol && (
          <g className="grid">
            <line
              x1={x0}
              y1={y1}
              x2={x3}
              y2={y1}
              className="rowHover">
            </line>
            <line
              x1={x0}
              y1={y2}
              x2={x3}
              y2={y2}
              className="rowHover">
            </line>
          </g>
        )}
        {hasCol && !hasRow && (
          <g className="grid">
            <line
              x1={x1}
              y1={y0}
              x2={x1}
              y2={y3}
              className="colHover">
            </line>
            <line
              x1={x2}
              y1={y0}
              x2={x2}
              y2={y3}
              className="colHover">
            </line>
          </g>
        )}
        {hasRow && hasCol && (
          <g className="grid">
            <line
              x1={x0}
              y1={y1 + this.props.cellSize / 2}
              x2={x2 - this.props.cellSize}
              y2={y1 + this.props.cellSize / 2}
              className="rowHover dashed">
            </line>
            <line
              x1={x1  + this.props.cellSize / 2}
              y1={y0 }
              x2={x1 + this.props.cellSize / 2}
              y2={y2 - this.props.cellSize}
              className="colHover dashed">
            </line>
            <rect
              x={x1}
              y={y1}
              width={this.props.cellSize}
              height={this.props.cellSize}
              className="cellHover"
            >
            </rect>
          </g>
        )}
      </g>
    )
  }
}

HeatMapHovers.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  cellSize: PropTypes.number,
  hoverRow: PropTypes.number,
  hoverCol: PropTypes.number,

};

export default HeatMapHovers


// WEBPACK FOOTER //
// ./src/charts/HeatMap/HeatMapHovers.js